import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormControl } from 'react-bootstrap';
import { createModal } from 'react-modal-promise';
import '../ReactModal/reactModal.scss';

function ProdigyModal({ close, needsTestLeads, allowExistingLeads }) {
  const [testVisitId, setTestVisitId] = useState();
  return (
    <div className="p-modal-container">
      <div className="p-modal">
        <div className="p-modal-text">
          <h2>Are you sure you want to import forms for this dealer?</h2>
        </div>
        <i
          onClick={() => close({ confirm: false })}
          className="modal-close close icon"
          alt="close"
        />
        <div className="p-modal-body">
          {needsTestLeads && (
            <p>
              {allowExistingLeads ? (
                <>
                  An existing lead can be specified for form collection,
                  otherwise a new test lead will be created. <br />
                  <br />
                  <FormControl
                    type="text"
                    value={testVisitId}
                    placeholder="Test Lead Visit Id"
                    onChange={e => setTestVisitId(e.target.value)}
                  />{' '}
                  <br />
                </>
              ) : (
                <>
                  This will create a test lead which will need to be manually
                  cleaned up. <br />
                </>
              )}
              Any lead created will have the name{' '}
              {'"TestFirstName TestLastName"'}. <br />
            </p>
          )}
        </div>
        <div className="p-modal-actions">
          <button
            className="btn btn-primary btn-large btn-large-default"
            onClick={() => close({ confirm: true, testVisitId })}
          >
            Import
          </button>
          <button
            className="btn btn-default btn-large"
            onClick={() => close({ confirm: false })}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}

ProdigyModal.propTypes = {
  close: PropTypes.func,
  needsTestLeads: PropTypes.bool,
  allowExistingLeads: PropTypes.bool,
};

const ImportCRMFormsModal = createModal(ProdigyModal);

export default ImportCRMFormsModal;
